import * as React from 'react';

function SvgArrowDownRightSquare(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path
				fillRule='evenodd'
				d='M15 2a1 1 0 00-1-1H2a1 1 0 00-1 1v12a1 1 0 001 1h12a1 1 0 001-1V2zM0 2a2 2 0 012-2h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2zm5.854 3.146a.5.5 0 10-.708.708L9.243 9.95H6.475a.5.5 0 100 1h3.975a.5.5 0 00.5-.5V6.475a.5.5 0 10-1 0v2.768L5.854 5.146z'
			/>
		</svg>
	);
}

export default SvgArrowDownRightSquare;
